import React from "react";
import { Box, Flex, Button } from "@chakra-ui/react";
import {
  ArrowForwardIcon,
  ArrowBackIcon,
} from "@chakra-ui/icons";

// `children` (e.g. question number / time taken) renders between Prev and Next, inside the sticky bar,
// so it can never scroll underneath it.
export const QSetHeader = ({ onChangeDyno, navigateToHome, disableNext, disablePrev, children }) => {
  return (
    <Box
      as="header"
      sx={{
        position: "sticky",
        top: "86px",
        background: "#f7fafb",
        zIndex: 1,
        display: "block",
        border:"none"
      }}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        gap="4"
        padding="2"
        minHeight="86px"
        maxWidth="1180"
        width="100%"
        margin="0 auto"
      >
        <Button flexShrink={0} fontSize={{ base: "sm", sm: "sm", md: "md" }} leftIcon={<ArrowBackIcon />} onClick={() => onChangeDyno(false)} colorScheme='blue' variant='outline' isDisabled={disablePrev}>Prev</Button>
        {children && <Box className="qset-header-info">{children}</Box>}
        { !disableNext ? <Button flexShrink={0} fontSize={{ base: "sm", sm: "sm", md: "md" }} rightIcon={<ArrowForwardIcon />} onClick={() => onChangeDyno(true)} colorScheme='blue' variant='outline' isDisabled={disableNext}>Next</Button>
        : <Button flexShrink={0} fontSize={{ base: "sm", sm: "sm", md: "md" }} rightIcon={<ArrowForwardIcon />} onClick={navigateToHome} colorScheme='blue' variant='outline'>Home</Button>
        }
      </Flex>
    </Box>
  );
};
